
import React, { useEffect } from 'react'
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextareaAutosize, TextField, Tooltip } from '@material-ui/core'
import { useState } from 'react';
import AddIssue from '../../t011/components/AddIssue';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import ReadMoreInline from '../../../shared_elements/components/ReadMoreInline';
import AddEditQuestion from './AddEditQuestion';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import { DeletePopUp, PageLoader } from '../../../shared_elements';
import { globalDeleteService, globalPostService, globalPutService } from '../../../globalServices';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { useSnackbar } from 'notistack';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import ImportQuestion from './ImportQuestion';
import { arrayMoveImmutable } from 'array-move';
import AddQuestion from './AddQuestion';
import { trackActivity } from '../../../utils/mixpanel';
const DragHandle = SortableHandle(() => <span style={{ paddingRight: '10px', display: 'inline-block', cursor: 'move' }}><DragIndicatorIcon /></span>);
const SortableItem = SortableElement(({ item, section, setAddEditQuestion, setDeleteQuestion, onEdit, sortIndex, params, currentFormDetail, onUpdateResponse }) => {
    return (
        <div>
            <Grid container alignItems='center' spacing={0} className='t003-document-sorting'>
                <Grid item sm='5' style={{ wordBreak: 'break-word' }}>
                    <div className='drag-handler-blk'>
                            {onCheckFormPermission(currentFormDetail) && section?.questions?.length > 1 ?
                                <DragHandle /> : null
                            }
                            <ReadMoreInline
                                text={item?.question}
                                maxLength='100'
                                readMoreText='show full question'
                            />
                            {item?.notes ?
                                <p className='question-notes' style={{ display: 'block' }}>
                                    <span>Notes:
                                        <ReadMoreInline
                                            text={item?.notes}
                                            maxLength='50'
                                        />
                                    </span>
                                </p> : null
                            }
                    </div>
                </Grid>
                <Grid item sm='1' style={{ wordBreak: 'break-word' }}>
                    {onCheckFormPermission(currentFormDetail) ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Tooltip title='Yes' placement='top' arrow>
                                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => onUpdateResponse(item, item?.status === 1 ? null : 1)}>
                                    {item?.status === 1
                                        ? <CheckCircleIcon style={{ color: '#2e7d32', fontSize: '22px' }} />
                                        : <CheckCircleOutlineIcon style={{ color: '#bdbdbd', fontSize: '22px' }} />
                                    }
                                </span>
                            </Tooltip>
                            <Tooltip title='No' placement='top' arrow>
                                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => onUpdateResponse(item, item?.status === 2 ? null : 2)}>
                                    {item?.status === 2
                                        ? <CancelIcon style={{ color: '#c62828', fontSize: '22px' }} />
                                        : <CancelOutlinedIcon style={{ color: '#bdbdbd', fontSize: '22px' }} />
                                    }
                                </span>
                            </Tooltip>
                        </div>
                    ) : (
                        item?.status ? (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 600, color: item?.status === 1 ? '#2e7d32' : '#c62828' }}>
                                {item?.status === 1
                                    ? <><CheckCircleIcon style={{ fontSize: '16px' }} /> Yes</>:
                                     item?.status === 2 ?
                                    <><CancelIcon style={{ fontSize: '16px' }} /> No</>: null
                                }
                            </span>
                        ) : null
                    )}
                </Grid>
                <Grid item sm='5' style={{ wordBreak: 'break-word' }}>
                    <ReadMoreInline
                        text={item?.answer}
                        maxLength='100'
                        readMoreText='show full answer'
                    />
                </Grid>
                <Grid item sm='1'>
                    {onCheckFormPermission(currentFormDetail) ?
                        <ul className="list-inline" style={{ float: 'right', display: 'flex' }}>
                            <Tooltip placement="top" title='Edit' arrow>
                                <li className="list-inline-item">
                                    <EditIcon style={{ cursor: "pointer" }} onClick={() => setAddEditQuestion({ modal: true, data: item, type: 'edit' })} color="primary" fontSize="small" />
                                </li>
                            </Tooltip>

                            <Tooltip placement="top" title='Delete' arrow>
                                <li className="list-inline-item">
                                    <DeleteOutlineIcon style={{ cursor: "pointer" }} onClick={() => setDeleteQuestion({ modal: true, data: item, })} color="secondary" fontSize="small" />
                                </li>
                            </Tooltip>
                        </ul> : null}
                </Grid>
            </Grid>
        </div>)
})
const SortableList = SortableContainer(({ section, params, setAddEditQuestion, setDeleteQuestion, currentFormDetail, onUpdateResponse }) => {
    return (
        <div className='docs-checklist-body'>
            {section?.questions?.map((item, index) => {
                return (
                    <SortableItem
                        section={section}
                        key={`item-${index}`}
                        item={item}
                        setDeleteQuestion={setDeleteQuestion}
                        sortIndex={index}
                        setAddEditQuestion={setAddEditQuestion}
                        index={index}
                        currentFormDetail={currentFormDetail}
                         onUpdateResponse={onUpdateResponse}
                    />
                )
            })}
        </div>
    )
})
export default function QuestionList({ sections, params, setDocumentCheckList, documentCheckList, getDocumentCheckList, currentFormDetail }) {
    const [addIssues, setAddIssue] = useState({})
    const [isLoading, setLoading] = useState(false)
    const [isPageLoading, setPageLoading] = useState(false)
    const [addEditQuestion, setAddEditQuestion] = useState({})
    const [addQuestion, setAddQuestion] = useState({})
    const [section, setSection] = useState(sections)
    const [deleteQuestion, setDeleteQuestion] = useState({})
    const [importQuestions, setImportQuestions] = useState({})
    const { enqueueSnackbar } = useSnackbar()
    useEffect(() => {
        setSection(sections)
    }, [sections?.questions])
    const onDeleteQuestion = async () => {
        setLoading(true)
        const response = await globalDeleteService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/sections/${section?.id}/questions/${deleteQuestion?.data?.id}/?asset_type=${params?.type}`, [deleteQuestion?.data])
        setLoading(false)
        if (checkApiStatus(response)) {
            setDeleteQuestion({})
            getDocumentCheckList()
            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
    }
    const updateQuestionsSort = (questions) => {
        setPageLoading(true);
        globalPostService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sort/sections/${section?.id}/questions/?asset_type=${params.type}`, questions.map((qus, index) => { return { id: qus.id, order: index + 1 } }))
            .then(response => {
                setPageLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar('Question Sorting updated successfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                }
            })
    }
    const onSortEnd = ({ oldIndex, newIndex }) => {
        setSection({ ...section, questions: arrayMoveImmutable(section.questions, oldIndex, newIndex) })
        updateQuestionsSort(arrayMoveImmutable(section.questions, oldIndex, newIndex));
    };
    const onUpdateResponse = async (item, responseValue) => {
        if (responseValue === 2 && !item?.answer) {
            enqueueSnackbar('Please fill answer to save No as value.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        } else {
            setSection(prev => ({
                ...prev,
                questions: prev.questions.map(q => q.id === item.id ? { ...q, status: responseValue } : q)
            }));
            const response = await globalPutService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/sections/${section?.id}/questions/${item?.id}/?asset_type=${params?.type}`, { ...item, status: responseValue });
            if (!checkApiStatus(response)) {
                setSection(prev => ({
                    ...prev,
                    questions: prev.questions.map(q => q.id === item.id ? { ...q, status: item.response } : q)
                }));
            }
        }
    };
    return (
        <div className='qs-section t003-docs'>
            {onCheckFormPermission(currentFormDetail) ?
                <ul className='list-inline flex-centered' style={{ marginBottom: '5px' }}>
                    <li className='list-inline-item'>
                        <Button startIcon={<AddIcon color='primary' fontSize='small' />} onClick={(e) => { e.stopPropagation(); setImportQuestions({ modal: true, sectionId: section.id }) }} color='primary' variant='outlined' size='small'>Import Question</Button>
                    </li>
                    <li className='list-inline-item'>
                        <Button onClick={() => setAddQuestion({ modal: true })} variant='contained' color='primary' size='small' style={{ marginRight: '10px' }}>+ Add Question</Button>
                    </li>
                </ul> : null}
            <div className='docs-checklist-hd'>
                <Grid container>
                    <Grid item md={5}>
                        <p>Question(s)</p>
                    </Grid>
                    <Grid item md={1}>
                        <p>Status</p>
                    </Grid>
                    <Grid item md={5}>
                        <p>Answer(s)</p>
                    </Grid>
                    <Grid item md={1}>
                        <p style={{ textAlign: 'right' }} >Action(s)</p>
                    </Grid>
                </Grid>
            </div>
            {section?.questions?.length ?
                <SortableList
                    setDeleteQuestion={setDeleteQuestion}
                    setAddEditQuestion={setAddEditQuestion}
                    helperClass='sortableHelper'
                    onSortEnd={onSortEnd}
                    section={section}
                    useDragHandle
                    params={params}
                    onUpdateResponse={onUpdateResponse}
                    currentFormDetail={currentFormDetail}
                /> : null}
            {!section?.questions?.length ?
                <div style={{ textAlign: 'center', padding: '4px' }}> No Records Found</div> : null}
            {isPageLoading ? <PageLoader /> : null}
            {addIssues.modal ?
                <AddIssue
                    addIssue={addIssues}
                    toggleModalFn={() => setAddIssue({ modal: false, data: null })}
                    getResponseBack={() => getDocumentCheckList()}
                /> : null
            }
            {addQuestion?.modal ?
                <AddQuestion
                    getDocumentCheckList={getDocumentCheckList}
                    addQuestion={addQuestion}
                    params={params}
                    section={section}
                    toggleModalFn={() => setAddQuestion({})}
                />
                : null}
            {addEditQuestion?.modal ?
                <AddEditQuestion
                    getDocumentCheckList={getDocumentCheckList}
                    addEditQuestion={addEditQuestion}
                    params={params}
                    section={section}
                    toggleModalFn={() => setAddEditQuestion({})}
                /> : null
            }
            {
                deleteQuestion?.modal ?
                    <DeletePopUp
                        modal={deleteQuestion.modal}
                        toggleModalFn={() => setDeleteQuestion({ modal: false, data: null })}
                        title={`Delete Question.`}
                        circularloader={isLoading}
                        content={<h4>Are you sure you want to Delete Question?</h4>}
                        deleteRecordFn={() => onDeleteQuestion(deleteQuestion?.data)} />
                    : null
            }
            {
                importQuestions?.modal ?
                    <ImportQuestion
                        params={params}
                        toggleModalFn={() => setImportQuestions({})}
                        importQuestions={importQuestions}
                    /> : null
            }
        </div>
    )
}
